import { render, staticRenderFns } from "./ExerciseItemCreate.vue?vue&type=template&id=7783408e&"
import script from "./ExerciseItemCreate.vue?vue&type=script&lang=js&"
export * from "./ExerciseItemCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports